<script setup lang="ts">
import ReactComponent from '@/components/React/ReactComponent.vue'
</script>
<template>
  <ReactComponent
    name="UserSubscriptionOverview"
    style="width: initial; height: initial"
  />
</template>
